import { render, staticRenderFns } from "./IndustryPillar.vue?vue&type=template&id=52cc42c3&scoped=true"
import script from "./IndustryPillar.vue?vue&type=script&lang=js"
export * from "./IndustryPillar.vue?vue&type=script&lang=js"
import style0 from "./IndustryPillar.vue?vue&type=style&index=0&id=52cc42c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc42c3",
  null
  
)

export default component.exports